import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AfterOauthLoginComponent } from './after-oauth-login/after-oauth-login.component';
import { LoginComponent } from './login/login.component';
import { ClarityModule } from '@clr/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {} from '@angular/common/http';
import { DeviceLoginDoneComponent } from './device-login-done/device-login-done.component';
import { ForgottenPasswordComponent } from './login/forgotten-password/forgotten-password.component';
import { NeedAuthGuard } from './needauthguard';
import { NeedRootGuard } from './needrootguard';
import { CryptoUnavailableComponent } from './login/crypto-unavailable/crypto-unavailable.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { DeletionComponent } from './deletion/deletion.component';
import { DeletionAfterOauthComponent } from './deletion-after-oauth/deletion-after-oauth.component';
import { UnsupportedBrowserComponent } from './login/unsupported-browser/unsupported-browser.component';
import '@cds/core/icon/register.js';
import { ClarityIcons, exclamationTriangleIcon } from '@cds/core/icon';
import { MuwDisclaimerPopupComponent } from './login/muw-disclaimer-popup/muw-disclaimer-popup.component';
import { UseInvitationComponent } from './use-invitation/use-invitation.component';
import { PasswordSignupComponent } from './use-invitation/password-signup/password-signup.component';
import { AUTH_URL } from 'cdss-common-lib';
import { AuthenticationService } from './auth.service';

ClarityIcons.addIcons(exclamationTriangleIcon);

@NgModule({
  declarations: [
    LoginComponent,
    AfterOauthLoginComponent,
    DeviceLoginDoneComponent,
    ForgottenPasswordComponent,
    CryptoUnavailableComponent,
    PasswordRecoveryComponent,
    DeletionComponent,
    DeletionAfterOauthComponent,
    UnsupportedBrowserComponent,
    MuwDisclaimerPopupComponent,
    UseInvitationComponent,
    PasswordSignupComponent,
  ],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    NeedAuthGuard,
    NeedRootGuard,
    { provide: 'Window', useValue: window },
    { provide: AUTH_URL, useClass: AuthenticationService },
  ]
})
export class AuthenticationModule {}
